<button mat-button color="warn" (click)="onClick()">
  <mat-icon>file_upload</mat-icon>
  {{translation.shared.chooseImage | transloco}}
</button>
<input type="file" id="fileUpload" name="fileUpload" accept="image/*" style="display:none;"/>

<img #croppie="croppie" [croppieOptions]="croppieOptions" (update)="handleUpdate($event)"/>
<!--<button (click)="getResult()">result</button>-->
